<script type="es6">

  // 重新定义tabs值（有包含参数值，切换不会变）
  function tabsChange($route, name) {
    let tabsList = JSON.parse(sessionStorage.getItem('tabs'));
    tabsList.forEach((val, i) => {
      if (val.title === name) {
        tabsList[i].name = $route.fullPath;
        return tabsList;
      }
    });
    sessionStorage.removeItem('tabs');
    sessionStorage.setItem('tabs', JSON.stringify(tabsList));
  }

  const apiUrl = configs.url;
  // 'process.env.URL_ROOT': '"http://59.42.10.82:8018"' // 开发版
  // 'process.env.URL_ROOT': '"http://192.168.0.32:8111"' // 测试版
  // 'process.env.URL_ROOT': '"http://www.xingyuansport.com:30004"' // 阿木系统
  // 'process.env.URL_ROOT': '"http://www.hcxr.net:30001"' // 阿木客户的分销地址
  // 'process.env.URL_ROOT': '"http://www.69-sport.com:30001"' // 客户的分销地址
  // const apiUrl = 'http://192.168.0.19:8090';
  // const apiUrl = 'http://59.42.10.82:8008';
  // const apiUrl = 'http://59.42.10.82:8009';
  // const apiUrl = 'http://59.42.10.82:8018';
  // const apiUrl = 'http://192.168.0.32:8111';
  // const apiUrl = 'http://www.xingyuansport.com:30004';
  // const apiUrl = 'http://localhost:8003/';
  // const apiUrl = 'http://192.168.0.19:8003';
  // const apiUrl = 'http://192.168.0.32:8103';
  // const apiUrl = 'http://www.xingyuansport.com:30004';

  // 登录后token头部值
  /* const Header = {
    headers: {
      // 'Accept': 'application/json',
      'Authorization': 'BasicAuth ' + sessionStorage.getItem('token')
    }
  }; */

  // 提交时间的开始时时间格式转换
  function timeFormatStart (times) {
    if (times) {
      const dtime = new Date(times);
      const y = dtime.getFullYear();
      const M = twoDigits(dtime.getMonth() + 1);
      const d = twoDigits(dtime.getDate());
      // const h = twoDigits(dtime.getHours());
      // const m = twoDigits(dtime.getMinutes());
      // const s = twoDigits(dtime.getSeconds());
      return y + '/' + M + '/' + d + ' ' + '00:00:00';
    } else {
      return times;
    }
  }

  // 提交时间的结束时时间格式转换
  function timeFormatEnd (times) {
    if (times) {
      const dtime = new Date(times);
      const y = dtime.getFullYear();
      const M = twoDigits(dtime.getMonth() + 1);
      const d = twoDigits(dtime.getDate());
      return y + '/' + M + '/' + d + ' ' + '23:59:59';
    } else {
      return times;
    }
  }

  // 提交时间+8个小时
  function timeFormatEight (times) {
    if (times) {
      const dtime = new Date(times);
      const y = dtime.getFullYear();
      const M = twoDigits(dtime.getMonth() + 1);
      const d = twoDigits(dtime.getDate());
      const H = dtime.getHours();
      return y + '/' + M + '/' + d + ' ' + dtime.getHours() + ':' + dtime.getMinutes() + ':' + dtime.getSeconds();
    } else {
      return times;
    }
  }

  // 提交时间+8个小时单日期的
  function timeFormatEightDate (times) {
    if (times) {
      const dtime = new Date(times);
      const y = dtime.getFullYear();
      const M = twoDigits(dtime.getMonth() + 1);
      const d = twoDigits(dtime.getDate());
      return y + '/' + M + '/' + d;
    } else {
      return times;
    }
  }

  /* 单位数转两位数 */
  function twoDigits(digits) {
    if (digits >= 0 && digits < 10) {
      return '0' + digits;
    } else {
      return digits;
    }
  }

  /** 浮点数值的最高进度是17位小数，但在进行运算的时候其精确度却远远不如整数；整数在进行运算的时候都会转成10进制； 而Java和JavaScript中计算小数运算时，都会先将十进制的小数换算到对应的二进制，一部分小数并不能完整的换算为二进制，这里就出现了第一次的误差。待小数都换算为二进制后，再进行二进制间的运算，得到二进制结果。然后再将二进制结果换算为十进制，这里通常会出现第二次的误差。
   所以(0.1+0.2)!=0.3 */
  /** 加法运算，避免数据相加小数点后产生多位数和计算精度损失。
   *  @param num1 + num2
   * @param num2
   * */
  function addition(num1, num2) {
    // console.log('加法', num1, num2);
    let ret;
    num1 = Number(num1);
    num2 = Number(num2);
    ret = (num1 * 1000 + num2 * 1000) / 1000;
    return ret;
  }

  /** 减法运算，避免数据相减小数点后产生多位数和计算精度损失。
   *  @params num1 - num2
   *  */
  function subtraction(num1, num2) {
    // console.log('减法', num1, num2);
    let ret;
    num1 = Number(num1);
    num2 = Number(num2);
    // ret = num1 - num2;
    ret = (num1 * 1000 - num2 * 1000) / 1000;
    return ret;
  }

  /** 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失。
   * @param num1
   * @param num2
   */
  function multiplication(num1, num2) {
    // console.log('乘加法', num1, num2);
    let ret;
    num1 = Number(num1);
    num2 = Number(num2);
    ret = ((num1 * 1000) * (num2 * 1000)) / 1000000;
    return ret;
  }

  /** 除法运算，避免数据相除小数点后产生多位数和计算精度损失。
   * @param num1
   * @param num2
   */
  function division(num1, num2) {
    // console.log('除法', num1, num2);
    let ret;
    num1 = Number(num1);
    num2 = Number(num2);
    ret = ((num1 * 1000) / (num2 * 1000)) / 1000000;
    return ret;
  }

  // 应用获取token
  function getToken(typeName, stateId, code) {
    return apiUrl + '/api/LoginRegister/GetToken?typeName=' + typeName + '&stateId=' + stateId + '&code=' + code;
  }

  // 获取供应商部署地址
  const getSPUrl = apiUrl + '/api/LoginRegister/GetSPUrl';

  // 获取分销网站的客户个性化信息
  const getWebClienData = apiUrl + '/api/LoginRegister/GetWebClienData';

  // 登录地址
  const loginUrl = apiUrl + '/api/LoginRegister/Login';

  // 注册地址
  const registerUrl = apiUrl + '/api/LoginRegister/RegisteAgentOrSupply';

  // 用手机号获取手机验证码
  function sendVerifyCode (phonenum, type) {
    return apiUrl + '/api/LoginRegister/SendVerifyCode?stype=' + type + '&phoneNumber=' + phonenum;
  }

  // 检验输入的分销商或供应商的账户 是否符合
  function checkAgentOrSupplyAccount(ctype, loginName) {
    return apiUrl + '/api/LoginRegister/CheckAgentOrSupplyAccount?ctype=' + ctype + '&loginName=' + loginName;
  }

  // 检验验证码
  function checkFindSmsCode(ctype, loginName, phoneNumber, verifyCode) {
    return apiUrl + '/api/LoginRegister/CheckFindSmsCode?ctype=' + ctype + '&loginName=' + loginName +
      '&phoneNumber=' + phoneNumber + '&verifyCode=' + verifyCode;
  }

  // 再次发送找回密码的验证码
  function sendFindPwdSmsCode(ctype, loginName, phoneNumber) {
    return apiUrl + '/api/LoginRegister/SendFindPwdSmsCode?ctype=' + ctype + '&loginName=' + loginName + '&phoneNumber=' + phoneNumber;
  }

  // 修改供应商或分销商的密码--忘记密码
  const findPwdChange = apiUrl + '/api/LoginRegister/FindPwdChange';

  // 修改密码
  const changeUserPwd = apiUrl + '/api/SysInfo/ChangeUserPwd';

  // 获取左侧栏菜单
  const getMenuInfoUrl = apiUrl + '/api/SysInfo/GetMenuInfo';

  // 获取分销商的主信息
  const getAgentMainInfo = apiUrl + '/api/SysInfo/GetAgentMainInfo';

  // 更改分销商自动付款状态
  const changeAgentAutoPayStatus = apiUrl + '/api/SysInfo/ChangeAgentAutoPayStatus';

  // 获取分销商的售后统计数据
  const getRefundCountInfo = apiUrl + '/api/SysInfo/GetRefundCountInfo';

  /** 公告管理 start */
  // 获取平台公告分页数据
  const loadPlatNoticePageData = apiUrl + '/api/NoticeInfo/LoadPlatNoticePageData';

  // 查看平台公告详情
  function getPlatNoticeById(noticeId) {
    return apiUrl + '/api/NoticeInfo/GetPlatNoticeById/' + noticeId;
  }

  // 获取供应商公告分页数据
  const loadSupplierNoticePageData = apiUrl +  '/api/NoticeInfo/LoadSupplierNoticePageData';

  // 查看供应商公告详情
  function getSupplierNoticeById(noticeId) {
    return apiUrl + '/api/NoticeInfo/GetSupplierNoticeById/' + noticeId;
  }

  // 加载对分销商开放的供应商
  // const getSupplierSelData = '/api/NoticeInfo/GetSupplierSelData';
  /** 公告管理 end */

  /** 货品管理 start */
  // 加载品牌下拉数据
  // const getBrandSelData = '/api/GoodsInfo/GetBrandSelData';

  // 加载码段下拉数据
  // const getSizeGroupSelData = '/api/GoodsInfo/GetSizeGroupSelData';

  // 加载分类下拉数据
  // const getClassSelData = '/api/GoodsInfo/GetClassSelData';

  // 货品列表分页数据
  const loadGoodsPageList = apiUrl + '/api/GoodsInfo/LoadGoodsPageList';

  // 查看货品详情
  function getGoodsInfoById(goodId) {
    return apiUrl + '/api/GoodsInfo/GetGoodsInfoById?goodsId=' + goodId;
  }

  // 下载商品主图
  function downMainImg(goodsId) {
    return apiUrl + '/api/GoodsInfo/DownMainImg?goodsId=' + goodsId;
  }

  // 下载商品图片压缩包
  function downImgZip(goodsId) {
    return apiUrl + '/api/GoodsInfo/DownImgZip?goodsId=' + goodsId;
  }

  // 获取组合销售绑定分页数据
  const loadAllGroupGoodsDetailPageData = apiUrl + '/api/GoodsInfo/LoadAllGroupGoodsDetailPageData';

  // 货品sku信息查询
  const searchGoodsSkuInfo = apiUrl + '/api/GoodsInfo/SearchGoodsSkuInfo';

  // 根据id获取组合销售编辑信息
  function getGroupGoodsDetailInfoById(id) {
    return apiUrl + '/api/GoodsInfo/GetGroupGoodsDetailInfoById/' + id;
  }

  // 保存组合销售
  function saveAddOrUpdateGroupGoodsCodeInfo(GroupBusinessCode, GroupGId) {
    return apiUrl + '/api/GoodsInfo/SaveAddOrUpdateGroupGoodsCodeInfo?GroupBusinessCode=' + GroupBusinessCode + '&GroupGId=' + GroupGId;
  }

  // 根据id删除组合销售信息
  function delGroupGoodsById(goodId) {
    return apiUrl + '/api/GoodsInfo/DelGroupGoodsById/' + goodId;
  }

  // 获取组合编码导入模板
  const getGroupGoodsImportExcelTemplet = apiUrl + '/api/GoodsInfo/GetGroupGoodsImportExcelTemplet';

  // 组合编码导入【仅支持文件放在FormData方式上传】
  const importGroupGoodsExcel = apiUrl + '/api/GoodsInfo/ImportGroupGoodsExcel';

  // 加载渠道列表分页数据
  const loadProxyAllStoreroomPageData = apiUrl + '/api/StoreroomInfo/LoadProxyAllStoreroomPageData';

  // 查看渠道详情
  function getStoreroomModelById(channelId) {
    return apiUrl + '/api/StoreroomInfo/GetStoreroomModelById/' + channelId;
  }

  // 是否开启售后自收
  function openOrCloseAfteSale(supplierCode, storeroomId, afterSale) {
    return apiUrl + '/api/StoreroomInfo/OpenOrCloseAfteSale?SupplierCode=' + supplierCode + '&StoreroomId=' + storeroomId + '&AfteSale=' + afterSale;
  }

  // 货号库存查询
  const loadPFGoodsPageData1 = apiUrl + '/api/StoreroomInfo/LoadGoodsIdStockPageData';

  // 点击货号查看货品详情
 /* function getGoodsInfoById(goodId) {
    return '/api/StoreroomInfo/GetGoodsInfoById?goodsId=' + goodId;
  } */

  // 获取渠道下拉框信息
  // const getAllStoreroomsList = '/api/StoreroomInfo/GetAllStoreroomsList';

  // 获取品牌下拉框信息
  // const getAllBrandsList = '/api/StoreroomInfo/GetAllBrandsList';

  // 渠道库存查询分页数据
  const loadAllStoreroomStockPageData = apiUrl + '/api/StoreroomInfo/LoadAllStoreroomStockPageData';

  // 渠道库存导出
  const exportStoreroomStockData = apiUrl + '/api/StoreroomInfo/ExportStoreroomStockData';

  // 成本价查询分页数据
  const loadAgentGoodsCostPricePageData = apiUrl + '/api/StoreroomInfo/LoadAgentGoodsCostPricePageData';

  // 成本查询导出
  const exportAgentGoodsCostPriceData = apiUrl + '/api/StoreroomInfo/ExportAgentGoodsCostPriceData';

  // 加载渠道配货号物流分页数据
  const getStoreroomGoodsLogisticPageData = apiUrl + '/api/StoreroomSetLogistic/GetStoreroomGoodsLogisticPageData';

  // 保存渠道配货号物流信息
  const saveStoreroomGoodsLogisticInfo = apiUrl + '/api/StoreroomSetLogistic/SaveStoreroomGoodsLogisticInfo';

  // 删除渠道配货号物流信息
  const delStoreroomGoodsLogisticByIds = apiUrl + '/api/StoreroomSetLogistic/DelStoreroomGoodsLogisticByIds';

  // 加载渠道配省份物流分页数据
  const getStoreroomProvinceLogisticPageData = apiUrl + '/api/StoreroomSetLogistic/GetStoreroomProvinceLogisticPageData';

  // 获取省份区域信息
  const getRegionProvinceList = apiUrl + '/api/StoreroomSetLogistic/GetRegionProvinceList';

  // 保存渠道配省份物流信息
  const saveStoreroomProvinceLogisticInfo = apiUrl + '/api/StoreroomSetLogistic/SaveStoreroomProvinceLogisticInfo';

  // 删除渠道配省份物流信息
  const delStoreroomProvinceLogisticByIds = apiUrl + '/api/StoreroomSetLogistic/DelStoreroomProvinceLogisticByIds';

  /** 宝贝管理 */
  // 获取店铺货品列表分页数据
  const loadAllShopGoodsPageData = apiUrl + '/api/ProductInfo/LoadAllShopGoodsPageData';

  // 店铺货品列表 导出excel
  const exportShopGoodsExcel = apiUrl + '/api/ProductInfo/ExportShopGoodsExcel';

  // 获取店铺货品的货品详情
  function getGoodsDetail(goodsId) {
    return apiUrl + '/api/ProductInfo/GetGoodsDetail?goodsId=' + goodsId;
  }

  // 获取店铺货品的下载货品图片压缩包
  function downloadGoodsImgZipRar(goodsId) {
    return apiUrl + '/api/ProductInfo/DownloadGoodsImgZipRar?goodsId=' + goodsId;
  }

  // 获取店铺货品的链接详情
  function getLinkDetailInfoById(goodsId, shopId) {
    return apiUrl + '/api/ProductInfo/GetLinkDetailInfoById?goodsId=' + goodsId + '&shopId=' + shopId;
  }

  // 店铺货品的链接详情的同步库存---单个货号下单个链接同步库存
  function synchOneLinkStock(shopId, goodsId, numId) {
    return apiUrl + '/api/ProductInfo/SynchOneLinkStock?shopId=' + shopId + '&goodsId=' + goodsId + '&numId=' + numId;
  }

  // 加载库存对接列表数据
  function loadGoodsStoreroomDatatableList(goodsId, shopId) {
    return apiUrl + '/api/ProductInfo/LoadGoodsStoreroomDatatableList?goodsId=' + goodsId + '&shopId=' + shopId;
  }

  // 获取分销商的渠道信息（ 店铺货品列表、店铺链接列表 批量设置渠道对接适用 ）——获取批量操作的渠道信息入口
  function getStoreroomListByShopId(shopId) {
    return apiUrl + '/api/ProductInfo/GetStoreroomListByShopId?shopId=' + shopId;
  }

  // 批量 保存货号库存对接的信息
  const batchSaveStoreroomGoodsDocking = apiUrl + '/api/ProductInfo/BatchSaveStoreroomGoodsDocking';

  // 批量 保存货号关闭库存对接信息
  const batchCloseGoodsStockDocking = apiUrl + '/api/ProductInfo/BatchCloseGoodsStockDocking';

  // 设置库存对接
  function saveStoreroomGoodsInfo(goodsId, shopId, status) {
    return apiUrl + '/api/ProductInfo/SaveStoreroomGoodsInfo?goodsId=' + goodsId + '&shopId=' + shopId + '&status=' + status;
  }

  // 单个货号同步库存
  function synchGoodsStock(shopId, goodsId) {
    return apiUrl + '/api/ProductInfo/SynchGoodsStock?shopId=' + shopId + '&goodsId=' + goodsId;
  }

  // 店铺货品的货品上下架
  function goodsGoOrDownIng(shopId, goodsId, type) { // type：上下架内容  1=上架   2=下架
    return apiUrl + '/api/ProductInfo/GoodsGoOrDownIng?shopId=' + shopId + '&goodsId=' + goodsId + '&type=' + type;
  }

  // 店铺链接分页数据
  const loadAllShopLinkPageData = apiUrl + '/api/ProductInfo/LoadAllShopLinkPageData';

  // 店铺链接列表 导出excel
  const exportShopLinkExcel = apiUrl + '/api/ProductInfo/ExportShopLinkExcel';

  // 查看店铺链接详情
  function getShopLinkSkuId(id, shopId) {
    return apiUrl + '/api/ProductInfo/GetShopLinkSkuId?numId=' + id + '&shopId=' + shopId;
  }

  // 店铺链接--修改链接商家编码后同步库存
  const synchrBatchLinkBusinessCode = apiUrl + '/api/ProductInfo/SynchrBatchLinkBusinessCode';

  // 库存对接数据列表
  function getStoreroom(numid, shopid) {
    return apiUrl + '/api/ProductInfo/GetStoreroom?numid=' + numid + '&shopid=' + shopid;
  }

  // 保存链接对接渠道的信息
  function saveStoreroomLinksInfo(numid, shopId, Status) {
    return apiUrl + '/api/ProductInfo/SaveStoreroomLinksInfo?numid=' + numid + '&shopId=' + shopId + '&Status=' + Status;
  }

  // 批量 保存链接渠道对接的信息
  const batchSaveStoreroomLinkDocking = apiUrl + '/api/ProductInfo/BatchSaveStoreroomLinkDocking';

  // 批量 保存链接关闭库存对接信息
  const batchCloseLinkStockDocking = apiUrl + '/api/ProductInfo/BatchCloseLinkStockDocking';

  // 店铺链接的同步库存--单个链接同步库存
  function synchLinkStock(shopId, numid) {
    return apiUrl + '/api/ProductInfo/SynchLinkStock?shopId=' + shopId + '&numid=' + numid;
  }

  // 店铺链接的链接上下架
  function getGoodsOnDrwn(shopId, numid, type) { // type：上下架内容  1=上架   2=下架
    return apiUrl + '/api/ProductInfo/GetGoodsOnDrwn?shopId=' + shopId + '&numid=' + numid + '&type=' + type;
  }

  // 批量 同步多个链接库存
  const batchSynchLinkStock = apiUrl + '/api/ProductInfo/BatchSynchLinkStock';

  // 无法识别链接分页数据
  const loadAllLinkErrorPageData = apiUrl + '/api/ProductInfo/LoadAllLinkErrorPageData';

  // 无法识别链接导出信息
  const exportShopErrorLinkExcel = apiUrl + '/api/ProductInfo/ExportShopErrorLinkExcel';

  // 查看无法识别链接详情
  function getLinkErrorSkuId(id, shopId) {
    return apiUrl + '/api/ProductInfo/GetLinkErrorSkuId?numId=' + id + '&shopId=' + shopId;
  }

  // 未识别详情商家编码编辑后批量同步   无法识别链接--同步商家编码
  const synchrBatchBusinessCode = apiUrl + '/api/ProductInfo/SynchrBatchBusinessCode';

  // 重新下载链接
  function downLink(shopId, numId) {
    return apiUrl + '/api/ProductInfo/DownLink?shopId=' + shopId + '&numId=' + numId;
  }

  // 运费查询分页数据
  const loadAllAgentStoreroomLogisticPostagePageData = apiUrl + '/api/StoreroomInfo/LoadAllAgentStoreroomLogisticPostagePageData';

  // 运费导出Excel
  const exportAgentStoreroomLogisticPostageData = apiUrl + '/api/StoreroomInfo/ExportAgentStoreroomLogisticPostageData';

  // 获取分销商所属得物店铺
  const getDewuShopList = apiUrl + '/api/DewuPrice/GetDewuShopList';

  // 发布出价
  // 得物出价 分页数据
  const loadDewuPricePageList = apiUrl + '/api/DewuPrice/LoadDewuPricePageList';

  // 得物出价 导出查询结果
  const exportDewuPriceExcel = apiUrl + '/api/DewuPrice/ExportDewuPriceExcel';

  // 批量取消选择链接的所有出价
  function batchCancelDewuPriceByNumId(shopId) {
    return apiUrl + '/api/DewuPrice/BatchCancelDewuPriceByNumId?shopId=' + shopId;
  }

  // 获取平台所有出价
  function downAllPlatBidPrice(shopId) {
    return apiUrl + '/api/DewuPrice/DownAllPlatBidPrice?shopId=' + shopId;
  }

  // 获取得物链接出价的日志
  function getDewuPriceLogList(priceId, numId) {
    return apiUrl + '/api/DewuPrice/GetDewuPriceLogList?priceId=' + priceId + '&numId=' + numId;
  }

  // 通过链接Id 获取得物出价详情
  function getDewuPriceDetailListByNumId(shopId, numId) {
    return apiUrl + '/api/DewuPrice/GetDewuPriceDetailListByNumId?shopId=' + shopId + '&numId=' + numId;
  }

  // 取消选择链接的所有出价
  function cancelDewuPriceByNumId(shopId, numId) {
    return apiUrl + '/api/DewuPrice/CancelDewuPriceByNumId?shopId=' + shopId + '&numId=' + numId;
  }

  // 下载查询【发布出价】
  function downDewuLinkPriceByNumId(shopId, numId) {
    return apiUrl + '/api/DewuPrice/DownDewuLinkPriceByNumId?shopId=' + shopId + '&numId=' + numId;
  }

  // 查询SKU最低价【发布出价】
  function getLowestPriceBySkuIds(shopId, numId) {
    return apiUrl + '/api/DewuPrice/GetLowestPriceBySkuIds?shopId=' + shopId + '&numId=' + numId;
  }

  // 计算可同步的库存【发布出价】
  function getStockBySkuIds(shopId, numId) {
    return apiUrl + '/api/DewuPrice/GetStockBySkuIds?shopId='+ shopId +'&numId=' + numId;
  }

  // 批量对Sku取消出价 【发布出价】
  function cancelDewuPriceBySkuIds(shopId, numId) {
    return apiUrl + '/api/DewuPrice/CancelDewuPriceBySkuIds?shopId='+ shopId + '&numId=' + numId;
  }

  // 确认发布出价 【发布出价】
  function confirmBidPrice(shopId) {
    return apiUrl + '/api/DewuPrice/ConfirmBidPrice?shopId=' + shopId;
  }

  // 店铺货号指定快递导入模板
  const getStoreroomGoodsLogisticImportExcelTemplet = apiUrl + '/api/StoreroomSetLogistic/GetStoreroomGoodsLogisticImportExcelTemplet';

  // 店铺货号指定快递导入【仅支持文件放在FormData方式上传】
  const importStoreroomGoodsLogisticExcel = apiUrl + '/api/StoreroomSetLogistic/ImportStoreroomGoodsLogisticExcel';

  /** 货品管理 end */

  /** 销售管理 start */
  // 导出售后列表数据
  const exportRefundExcel = apiUrl + '/api/Refund/ExportRefundExcel';

  // 售后列表分页数据
  const loadRefundPageData = apiUrl + '/api/Refund/LoadRefundPageData';

  // 根据售后单号获取售后日志
  function getRefundLogs(refundId) {
    return apiUrl + '/api/Refund/GetRefundLogs?refundId=' + refundId;
  }

  // 售后单撤回到(待受理)操作
  function changeRefundStatus(refundId) {
    return apiUrl + '/api/Refund/ChangeRefundStatus?refundId=' + refundId;
  }

  // 终止（关闭）售后单
  function closeRefund(refundId) {
    return apiUrl + '/api/Refund/CloseRefund?refundId=' + refundId;
  }

  // 根据渠道Id获取渠道收货信息
  function getAgentStoreroomById(storeroomId) {
    return apiUrl + '/api/Refund/GetAgentStoreroomById?storeroomId=' + storeroomId;
  }

  // 受理售后单
  function shouLiRefund(refundId, storeroomId, isOrderBack, backStoreroomInfo, extMoney, remarkMessage) {
    return apiUrl + '/api/Refund/ShouLiRefund?refundId=' + refundId + '&storeroomId=' + storeroomId + '&isOrderBack=' + isOrderBack + '&backStoreroomInfo=' + backStoreroomInfo + '&extMoney=' + extMoney + '&remarkMessage=' + remarkMessage;
  }

  // 对一笔售后单修改售后类型
  const saveRefundReType = apiUrl + '/api/Refund/SaveRefundReType';

  // 对一笔售后单修改售后原因
  function saveRefundReason(refundId, refundReasonId) {
    return apiUrl + '/api/Refund/SaveRefundReason?refundId=' + refundId + '&refundReasonId=' + refundReasonId;
  }

  // 对一笔售后单修改售后明细
  const saveRefundDetails = apiUrl + '/api/Refund/SaveRefundDetails';

  // 根据售后单号获取订单售后单关系数据
  function getOrderRefundRelationList(refundId) {
    return apiUrl + '/api/Refund/GetOrderRefundRelationList?refundId=' + refundId;
  }

  // 根据订单号加载订单数据（包含主单、订单明细、仓库信息、订单售后关系）
  function getOrderData(orderId) {
    return apiUrl + '/api/Refund/GetOrderData?orderId=' + orderId;
  }

  // 检验退回物流单号是否被其他售后单使用
  function checkRefundExpressNumIsUsed(refundId, logisticId, expressNum) {
    return apiUrl + '/api/Refund/CheckRefundExpressNumIsUsed?refundId=' + refundId + '&logisticId=' + logisticId + '&expressNum=' + expressNum;
  }

  // 保存退回物流信息
  function saveRefundLogisticInfo(refundId, logisticId, expressNum, extMoney, type) {
    if (type) {
      return apiUrl + '/api/Refund/SaveRefundLogisticInfo?refundId=' + refundId + '&logisticId=' + logisticId + '&expressNum=' + expressNum + '&extMoney=' + extMoney + '&type=' + type;
    } else {
      return apiUrl + '/api/Refund/SaveRefundLogisticInfo?refundId=' + refundId + '&logisticId=' + logisticId + '&expressNum=' + expressNum + '&extMoney=' + extMoney;
    }
  }

  // 提交退款金额（分销商向买家退款）
  function saveRefundTuiMoney(refundId, tuiMoney) {
    return apiUrl + '/api/Refund/SaveRefundTuiMoney?refundId=' + refundId + '&tuiMoney=' + tuiMoney;
  }

  // 修改分销商额外退费金额
  function saveAgentPXExtMoney(refundId, money) {
    return apiUrl + '/api/Refund/SaveAgentPXExtMoney?refundId=' + refundId + '&money=' + money;
  }

  // 修改分销商内部备注
  function saveAgentRemark(refundId, remark) {
    return apiUrl + '/api/Refund/SaveAgentRemark?refundId=' + refundId + '&remark=' + remark;
  }

  // 提交售后留言
  function saveRefundMessage(refundId, remark) {
    return apiUrl + '/api/Refund/SaveRefundMessage?refundId=' + refundId + '&remark=' + remark;
  }

  // 根据渠道、运单号获取异常收货数据
  function getRefundDailyReturnGoods(storeroomId, expressNum) {
    return apiUrl + '/api/Refund/GetRefundDailyReturnGoods?storeroomId=' + storeroomId + '&expressNum=' + expressNum;
  }

  // 查看确认收货列表
  function getRefundLogisticData(refundId) {
    return apiUrl + '/api/Refund/GetRefundLogisticData?refundId=' + refundId;
  }

  // 售后单确认收货
  function confirmReceipt(refundId) {
    return apiUrl + '/api/Refund/ConfirmReceipt?refundId=' + refundId;
  }

  // 售后单重新提交
  function refundResubmit(refundId) {
    return apiUrl + '/api/Refund/RefundResubmit?refundId=' + refundId;
  }

  // 创建换货新订单
  function createNewOrder(refundId) {
    return apiUrl + '/api/Refund/CreateNewOrder?refundId=' + refundId;
  }

  // 获取修改换货新订单列表
  function getCreateNewOrder(refundId) {
    return apiUrl + '/api/Refund/GetCreateNewOrder?refundId=' + refundId;
  }

  // 创建换货新订单（新版）
  function newCreateNewOrder(refundId) {
    return apiUrl + '/api/Refund/NewCreateNewOrder?refundId=' + refundId;
  }

  // 根据售后单号获取售后单详情（包含售后主单、售后明细、售后留言）
  function getRefundDataByRefundId(refundId) {
    return apiUrl + '/api/Refund/GetRefundDataByRefundId?refundId=' + refundId;
  }

  // 检测退回运单号是否已被其他售后单使用
  function checkExpressNumIsUsed(refundId) {
    return apiUrl + '/api/Refund/CheckExpressNumIsUsed?refundId=' + refundId;
  }

  // 提交售后申请
  const saveRefundInfo = apiUrl + '/api/Refund/SaveRefundInfo';

  // 获取订单导入模板
  const getOrderImportExcelTemplet = apiUrl + '/api/Order/GetOrderImportExcelTemplet';

  // 订单导入
  const importOrderExcel = apiUrl + '/api/Order/ImportOrderExcel';

  // 分销端 订单列表分页数据 --- 新的
  const getAgentOrderListPageData = apiUrl + '/api/Order/GetAgentOrderListPageData';

  // 订单列表分页数据
  const loadOrderPageList = apiUrl + '/api/Order/LoadOrderPageList';

  // 订单列表分页数据---复制版   分销端 线上平台已审核的订单列表分页数据
  const getPlatformCommitOrderListPageData = apiUrl + '/api/Order/GetPlatformCommitOrderListPageData';

  // 批量付款
  const batchPayOrder = apiUrl + '/api/Order/BatchPayOrder';

  // 全部付款
  const payAllOrder = apiUrl + '/api/Order/PayAllOrder';

  // 合单操作
  const mergeOrder = apiUrl + '/api/Order/MergeOrder';

  // 审核订单
  const verifyOrder = apiUrl + '/api/Order/VerifyOrder';

  // 审核单个订单
  function verifyOrderSingle(orderId) {
    return apiUrl + '/api/Order/VerifyOrderSingle?orderId=' + orderId;
  }

  // 一键审单
  const verifyAllOrder = apiUrl + '/api/Order/VerifyAllOrder';

  // 激活订单
  const batchActiveOrder = apiUrl + '/api/Order/BatchActiveOrder';

  // 激活单个订单
  function activeOrderSingle(orderId) {
    return apiUrl + '/api/Order/ActiveOrderSingle?orderId=' + orderId;
  }

  // 取消订单
  const batchCancelOrder = apiUrl + '/api/Order/BatchCancelOrder';

  // 取消单个订单
  function cancelOrderSingle(orderId) {
    return apiUrl + '/api/Order/CancelOrderSingle?orderId=' + orderId;
  }

  // 修改单个订单的卖家留言和分销内部备注
  const editRemarkMemoByOrderId = apiUrl + '/api/Order/EditRemarkMemoByOrderId';

  // 批量编辑订单内部备注（分销商备注）
  const batchEditAgentRemark = apiUrl + '/api/Order/BatchEditAgentRemark';

  // 批量编辑卖家备注
  const batchEditSellerMemo = apiUrl + '/api/Order/BatchEditSellerMemo';

  // 批量同步订单的线上发货信息
  const syncOnlineOrderSend = apiUrl + '/api/Order/SyncOnlineOrderSend';

  // 编辑卖家备注
  const editSellerMemo = apiUrl + '/api/Order/EditSellerMemo';

  // 编辑单个卖家备注
  const editSellerMemoSingle = apiUrl + '/api/Order/EditSellerMemoSingle';

  // 编辑内部备注
  const editAgentRemark = apiUrl + '/api/Order/EditAgentRemark';

  // 编辑单个订单内部备注
  const editAgentRemarkSingle = apiUrl + '/api/Order/EditAgentRemarkSingle';

  // 撤回订单
  function revokeOrder(orderId) {
    return apiUrl + '/api/Order/RevokeOrder?orderId=' + orderId;
  }

  // 获取订单明细
  function getOrderDetail(orderId) {
    return apiUrl + '/api/Order/GetOrderDetail?orderId=' + orderId;
  }

  // 分销商根据订单号修改物流运单号
  function editOrderExpressInfo(orderId, logisticId, expressNum) {
    return apiUrl + '/api/Order/EditOrderExpressInfo?orderId=' + orderId + '&logisticId=' + logisticId + '&expressNum=' + expressNum;
  }

  // 保存订单修改物流信息 -- 订单待审修改物流公司
  const saveOrderLogistic = apiUrl + '/api/Order/SaveOrderLogistic';

  // 取消订单同步失败标记
  function cancelOrderAsyncFailFlag(orderId) {
    return apiUrl + '/api/Order/CancelOrderAsyncFailFlag?orderId=' + orderId;
  }

  // 批量撤回
  const batchRevokeOrder = apiUrl + '/api/Order/BatchRevokeOrder';

  // 获取订单成本
  const getOrderCost = apiUrl + '/api/Order/GetOrderCost';

  // 拆分订单
  const manualSplitOrder = apiUrl + '/api/Order/ManualSplitOrder';

  // 查看拆分订单信息
  function viewSplitOrderInfo(orderId) {
    return apiUrl + '/api/Order/ViewSplitOrderInfo?orderId=' + orderId;
  }

  // 改货 根据货号获取品名和零售价
  function getGoodsInfoByGoodsId(goodsId) {
    return apiUrl + '/api/Order/GetGoodsInfoByGoodsId?goodsId=' + goodsId;
  }

  // 保存改货信息
  const saveChangeGoods = apiUrl + '/api/Order/SaveChangeGoods';

  // 根据订单号获取可改仓的渠道信息
  function getOrderChangeStoreroom(orderId) {
    return apiUrl + '/api/Order/GetOrderChangeStoreroom?orderId=' + orderId;
  }

  // 保存收货信息
  const saveReceiveInfo = apiUrl + '/api/Order/SaveReceiveInfo';

  // 保存订单的改仓信息
  const saveOrderChangeStoreroom = apiUrl + '/api/Order/SaveOrderChangeStoreroom';

  // 验证待添加的订单货品
  const verifyAppendGoods = apiUrl + '/api/Order/VerifyAppendGoods';

  // 添加订单货品
  const appendGoods = apiUrl + '/api/Order/AppendGoods';

  // 渠道重配
  function resetOrderStoreroom(orderId) {
    return apiUrl + '/api/Order/ResetOrderStoreroom?orderId=' + orderId;
  }

  // 批量渠道重配
  const batchResetOrderStoreroom = apiUrl + '/api/Order/BatchResetOrderStoreroom';

  // 智能拆单
  const autoSplitOrder = apiUrl + '/api/Order/AutoSplitOrder';

  // 获取一条订单明细中可用的渠道信息
  function getOrderDetailStoreroomInfo(orderId, detailId) {
    return apiUrl + '/api/Order/GetOrderDetailStoreroomInfo?orderId=' + orderId + '&detailId=' + detailId;
  }

  // 获取一个订单所有明细中可用的渠道信息
  function getOrderAllDetailStoreroomInfo(orderId) {
    return apiUrl + '/api/Order/GetOrderAllDetailStoreroomInfo?orderId=' + orderId;
  }

  // 获取订单日志
  function getOrderLogs(orderId) {
    return apiUrl + '/api/Order/GetOrderLogs?orderId=' + orderId;
  }

  // 对账导出
  function exportOrderExcel(eType) {
    return apiUrl + '/api/Order/ExportOrderExcel?eType=' + eType;
  }

  // 导出明细
  function exportDetailExcel(eType) {
    return apiUrl + '/api/Order/ExportDetailExcel?eType=' + eType;
  }

  // 店铺售价分页数据
  const getShopGoodsPricePageList = apiUrl + '/api/ShopGoodsPrice/GetShopGoodsPricePageList';

  // 获取单个店铺售价信息
  function getShopGoodsPriceById(id) {
    return apiUrl + '/api/ShopGoodsPrice/GetShopGoodsPriceById/' + id;
  }

  // 修改单个店铺售价信息
  const updateShopGoodsPrice = apiUrl + '/api/ShopGoodsPrice/UpdateShopGoodsPrice';

  // 删除店铺售价信息
  const deleteShopGoodsPriceById = apiUrl + '/api/ShopGoodsPrice/DeleteShopGoodsPriceById';

  // 店铺货品售价导出
  const exportShopGoodsPriceExcel = apiUrl + '/api/ShopGoodsPrice/ExportShopGoodsPriceExcel';

  // 获取店铺货品售价导入模板
  const getShopGoodsPriceImportExcelTemplet = apiUrl + '/api/ShopGoodsPrice/GetShopGoodsPriceImportExcelTemplet';

  // 店铺货品售价导入【仅支持文件放在FormData方式上传】
  const importShopGoodsPriceExcel = apiUrl + '/api/ShopGoodsPrice/ImportShopGoodsPriceExcel';

  // 获取价格可选范围下拉框信息
  const getPriceRangeSelData = apiUrl + '/api/Order/GetPriceRangeSelData';

  // 获取折扣可选范围下拉框信息
  const getCostDiscountSelData = apiUrl + '/api/Order/GetCostDiscountSelData';

  // 获取上市年份
  const getMarketYearSelData = apiUrl + '/api/Order/GetMarketYearSelData';

  // 查询零售下单货品库存信息分页数据 （按照货号个数分页）
  const getRetailGoodsPageData = apiUrl + '/api/Order/GetRetailGoodsPageData';

  // 导出库存的导出字段选择
  const getStockExportColumn = apiUrl + '/api/Order/GetStockExportColumn';

  // 零售下单 导出库存
  const exportGoodsIdStockExcel = apiUrl + '/api/Order/ExportGoodsIdStockExcel';

  // 获取当前登录用户的分销商的购物车信息
  const getShoppingCartData = apiUrl + '/api/Order/GetShoppingCartData';

  // 添加货品到购物车
  const addToShoppingCart = apiUrl + '/api/Order/AddToShoppingCart';

  // 删除购物车里的货品
  function delShoppingCartById(type) {
    return apiUrl + '/api/Order/DelShoppingCartById?clearAll=' + type;
  }

  // 检验72小时内该收货人是否有订单
  function checkReceiveNameHaveOrders(receiveName) {
    return apiUrl + '/api/Order/CheckReceiveNameHaveOrders?receiveName=' + receiveName;
  }

  // 零售订单结算 --- 购物车结算
  const settlementOrder = apiUrl + '/api/Order/SettlementOrder';

  // 提交订单 --- 购物车提交订单
  const submitOrders = apiUrl + '/api/Order/SubmitOrders';

  /** 销售管理 end */

  /** 资金管理 start */
  // 获取充值工单分页数据
  const getRechargeWorkOrderList = apiUrl + '/api/WorkOrder/GetRechargeWorkOrderList';

  // 删除充值工单
  function deleteRechargeWorkOrder(orderId) {
    return apiUrl + '/api/WorkOrder/DeleteRechargeWorkOrder/' + orderId;
  }

  // 获取申诉工单分页数据
  const getAppealWorkOrderList = apiUrl + '/api/WorkOrder/GetAppealWorkOrderList';

  // 新增或修改申诉工单 id: 0=新增 id=编辑对应的工单id
  function saveAppealWorkOrder(id, OrderId, Amount, AppealReason) {
    return apiUrl + '/api/WorkOrder/SaveAppealWorkOrder/' + id + '?OrderId=' + OrderId + '&Amount=' + Amount + '&AppealReason=' + AppealReason;
  }

  // 删除申诉工单
  function deleteAppealWorkOrder(id) {
    return apiUrl + '/api/WorkOrder/DeleteAppealWorkOrder/' + id;
  }

  // 验证订单号是否已经创建过申诉工单
  function checkOrderIdCreateAppealWorkOrder(orderNum) {
    return apiUrl + '/api/WorkOrder/CheckOrderIdCreateAppealWorkOrder/' + orderNum;
  }

  // 提交申诉工单或撤回申诉工单
  function changeAppealWorkOrderZt(orderNum, Zt) {
    return apiUrl + '/api/WorkOrder/ChangeAppealWorkOrderZt/' + orderNum + '?Zt=' + Zt;
  }

  // 查看日志（充值工单、申诉工单）
  const getWorkOrderLogList = apiUrl + '/api/WorkOrder/GetWorkOrderLogList';

  // 获取平台端账户充值数据
  function getFundAccountList(AType) {
    return apiUrl + '/api/WorkOrder/GetFundAccountList?AType=' + AType;
  }

  // 提交充值申请
  function saveRechargeWorkOrder(PayNo, Amount, AccountId, PayType, AgentName) {
    return apiUrl + '/api/WorkOrder/SaveRechargeWorkOrder?PayNo=' + PayNo + '&Amount=' + Amount + '&AccountId=' + AccountId + '&PayType=' + PayType + '&AgentName=' + AgentName;
  }

  // 修改分销商的支付密码
  const editPayPwd = apiUrl + '/api/WorkOrder/EditPayPwd';

  // 加载分销商资金流水交易类型下拉数据
  const getWaterStatus = apiUrl + '/api/SelectsInfo/GetWaterStatus';

  // 获取资金流水分页数据
  const getAccountBalanceHistoryDetailList = apiUrl + '/api/WorkOrder/GetAccountBalanceHistoryDetailList';

  // 导出资金流水
  const exportAccountBalanceHistoryDetailList = apiUrl + '/api/WorkOrder/ExportAccountBalanceHistoryDetailList';

  /** 资金管理 end */

  // 获取当前分销商的所有角色——下拉框的
  const getClientRoleData = apiUrl + '/api/SysInfo/GetClientRoleData';

  // 添加分销商用户
  const saveUser = apiUrl + '/api/SysInfo/SaveUser';

  // 获取用户分页数据
  const getUseList = apiUrl + '/api/SysInfo/GetUseList';

  // 获取当前分销商的QQ
  const getProxyQQ = apiUrl + '/api/SysInfo/GetProxyQQ';

  // 保存分销商QQ
  function saveProxyQQ(qqNum) {
    return apiUrl + '/api/SysInfo/SaveProxyQQ?qq=' + qqNum;
  }

  // 用户重置密码
  function resetPwd (userId) {
    return apiUrl + '/api/SysInfo/ResetPwd?userId=' + userId;
  }

  // 更改用户状态：启用=1    停用=2
  function changeStatus(userId, status) {
    return apiUrl + '/api/SysInfo/ChangeStatus?userId=' + userId + '&status=' + status;
  }

  // 删除用户
  function deleteUser(userId) {
    return apiUrl + '/api/SysInfo/DeleteUser?userId=' + userId;
  }

  // 获取角色分页数据
  const getRoleList = apiUrl + '/api/SysInfo/GetRoleList';

  // 获取权限列表数据和角色已选择的权限数据--树结构
  function getRoleCompetenceData(roleId) {
    return apiUrl + '/api/SysInfo/GetRoleCompetenceData?roleId=' + roleId;
  }

  // 设置角色权限--保存角色设置的参数
  const saveRoleCompetenceData = apiUrl + '/api/SysInfo/SaveRoleCompetenceData';

  // 保存角色数据
  const saveRole = apiUrl + '/api/SysInfo/SaveRole';

  // 更改角色状态
  function changeRoleStatus(roleId, status) {
    return apiUrl + '/api/SysInfo/ChangeRoleStatus?roleId=' + roleId + '&status=' + status;
  }

  // 删除角色
  function deleteRole(RoleId) {
    return apiUrl + '/api/SysInfo/DeleteRole?RoleId=' + RoleId;
  }

  // 获取店铺分页数据
  const loadAgentShopPageData = apiUrl + '/api/ShopInfo/LoadAgentShopPageData';

  // 获取平台来源下拉框信息
  // const getAllPXOpenPlatformList = '/api/ShopInfo/GetAllPXOpenPlatformList';

  // 同步整店库存
  function updateOneShopGoodsStock(shopId) {
    return apiUrl + '/api/ShopInfo/UpdateOneShopGoodsStock?shopId=' + shopId;
  }

  // 根据ID获取店铺信息
  function getShopModelById(shopId) {
    return apiUrl + '/api/ShopInfo/GetShopModelById/' + shopId;
  }

  // 保存店铺信息
  const saveAddOrUpdateShopInfo = apiUrl + '/api/ShopInfo/SaveAddOrUpdateShopInfo';

  // 修改店铺的使用状态
  function changeShopLocakStatusById(shopId, status) {
    return apiUrl + '/api/ShopInfo/ChangeShopLocakStatusById/' + shopId + '?lockStatus=' + status;
  }

  // 根据id删除店铺信息
  function delShopInfoById(shopId) {
    return apiUrl + '/api/ShopInfo/DelShopInfoById/' + shopId;
  }

  // 查看店铺信息详情---1为AppSecret；2为Sessionkey
  /* function getShopDockingKeyword(shopId, keyType) {
     // return '/api/ShopInfo/CheckShopApplictionDatil/' + shopId;
     return '/api/ShopInfo/GetShopDockingKeyword?shopId=' + shopId + '&keyType=' + keyType;
   } */

  // 获取全部渠道信息 店铺对接渠道信息
  function loadAllShopBindStoreroomAndStoreroomData(shopId) {
    return apiUrl + '/api/ShopInfo/LoadAllShopBindStoreroomAndStoreroomData/' + shopId;
  }

  // 保存店铺对接渠道的信息
  function saveShopBindStoreroomInfo(shopId, lStockCost, lSendRate, isLimitStockCost, isLimitSendRate) {
    return apiUrl + '/api/ShopInfo/SaveShopBindStoreroomInfo?shopId=' + shopId + '&shopStockCost=' + lStockCost + '&shopSendRate=' + lSendRate + '&isShopLimitStockCost=' + isLimitStockCost + '&isShopLimitSendRate=' + isLimitSendRate;
  }

  // 获取店铺对接的关键字段
  function getShopDockingKeyword(shopId) {
    return apiUrl + '/api/ShopInfo/GetShopDockingKeyword?shopId=' + shopId;
  }

  // 查询店铺同步订单设置
  function getSynchTradeSetting(shopId) {
    return apiUrl + '/api/ShopInfo/GetSynchTradeSetting?shopId=' + shopId;
  }

  // 店铺订单同步设置
  const synchTradeSetting = apiUrl + '/api/ShopInfo/SynchTradeSetting';

  // 查看拒绝原因
  function viewRejectReason(shopId) {
    return apiUrl + '/api/ShopInfo/ViewRejectReason?shopId=' + shopId;
  }

  // 获取全部渠道信息
  const loadAllStoreroomData = apiUrl + '/api/ShopInfo/LoadAllStoreroomData';

  // 分销商绑定供应商数据——获取绑定的供销商
  const getBindSupplier = apiUrl + '/api/SysInfo/GetBindSupplier';

  // 供应端保存绑定
  function saveBindSupplier(loginName, loginPwd) {
    return apiUrl + '/api/SysInfo/SaveBindSupplier?LogName=' + loginName + '&pwd=' + loginPwd;
  }

  // 供应端解除绑定
  const relieveSupplierBind = apiUrl + '/api/SysInfo/RelieveSupplierBind';

  /** 数据下载 */
  // 根据店铺Id获取数据下载的同步控制列表
  function getDockingSynchTypeList(shopId) {
    return apiUrl + '/api/ShopDataDownload/GetDockingSynchTypeList?shopId=' + shopId;
  }

  // 根据店铺Id、类型Id修改时间节点、频率
  function changeShopAsynTimeById(shoId, typeId, typeTime, pingRate) {
    return apiUrl + '/api/ShopDataDownload/ChangeShopAsynTimeById?shoId=' + shoId + '&typeId=' + typeId + '&typeTime=' + typeTime + '&pingRate=' + pingRate;
  }

  // 根据店铺Id、类型Id更改同步控制是否停用
  function changeShopStatusById(shoId, typeId, typeStatus) {
    return apiUrl + '/api/ShopDataDownload/ChangeShopStatusById?shoId=' + shoId + '&typeId=' + typeId + '&typeStatus=' + typeStatus;
  }

  // 单笔订单下载
  function downOrderById(shopId, orderId, ati) {
    return apiUrl + '/api/ShopDataDownload/DownOrderById?shopId=' + shopId + '&orderId=' + orderId + '&ati=' + ati;
  }

  // 按创建时间进行订单下载
  function downOrderByCreateTime(shopId, beginCreateTime, endCreateTime, ati) {
    return apiUrl + '/api/ShopDataDownload/DownOrderByCreateTime?shopId=' + shopId + '&beginCreateTime=' + beginCreateTime + '&endCreateTime=' + endCreateTime + '&ati=' + ati;
  }

  // 单笔售后单下载
  function downReOrderById(shopId, afterSaleOId) {
    return apiUrl + '/api/ShopDataDownload/DownReOrderById?shopId=' + shopId + '&afterSaleOId=' + afterSaleOId;
  }

  // 按创建时间进行售后单下载
  function downReOrderByCreateTime(shopId, beginCreateTime, endCreateTime) {
    return apiUrl + '/api/ShopDataDownload/DownReOrderByCreateTime?shopId=' + shopId + '&beginCreateTime=' + beginCreateTime + '&endCreateTime=' + endCreateTime;
  }

  // 平台链接商品下载
  function downGoodsByLinkId(linkId, shopId) {
    return apiUrl + '/api/ShopDataDownload/DownGoodsByLinkId?linkId=' + linkId + '&shopId=' + shopId;
  }

  // 下载整店商品
  function downShopGoodsList(shopId) {
    return apiUrl + '/api/ShopDataDownload/DownShopGoodsList?shopId=' + shopId;
  }

  // 数据列表
  function getShopAppInfoById(shopId) {
    return apiUrl + '/api/ShopDataDownload/GetShopAppInfoById?shopId=' + shopId;
  }

  // 重置时间
/* function changeShopAsynTimeById(shoId, type, typeTime) { // type: 1 订单,2 库存，3 商品，4 售后单
    return '/api/ShopDataDownload/ChangeShopAsynTimeById?shoId=' + shoId + '&type=' + type + '&typeTime=' + typeTime;
  } */

  // 修改启停用状态
 /* function changeShopStatusById(shoId, type, typeStatus) { // type: 1 订单,2 库存，3 商品，4 售后单  typeStatus: 启用 true，停用 false
    return '/api/ShopDataDownload/ChangeShopStatusById?shoId=' + shoId + '&type=' + type + '&typeStatus=' + typeStatus;
  } */

  /* 报表管理 */
  // 自营仓成本价管理
  // 加载分销商的自营渠道
  const getSelftStoreroomIdByClientId = apiUrl + '/api/SelfStoreCost/GetSelftStoreroomIdByClientId';

  // 自营仓真实货品成本分页数据
  const getSelftStoreCostPageList = apiUrl + '/api/SelfStoreCost/GetSelftStoreCostPageList';

  // 导出自营仓成本
  const exportSelfCostExcel = apiUrl + '/api/SelfStoreCost/ExportSelfCostExcel';

  // 修改自营仓成本
  function editCostDiscout(goodsId, storeroomId, discount) {
    return apiUrl + '/api/SelfStoreCost/EditCostDiscout?goodsId=' + goodsId + '&storeroomId=' + storeroomId + '&discount=' + discount;
  }

  // 获取自营仓货品导入模板
  const getSelfCostImportExcelTemplet = apiUrl + '/api/SelfStoreCost/GetSelfCostImportExcelTemplet';

  // 导入自营仓货品Excel【仅支持文件放在FormData方式上传】
  const importSelfCostExcel = apiUrl + '/api/SelfStoreCost/ImportSelfCostExcel';

  // 获取成本日志数据
  function getSelfCostLog(goodsId, storeroomId) {
    return apiUrl + '/api/SelfStoreCost/GetSelfCostLog?goodsId='+ goodsId + '&storeroomId=' + storeroomId;
  }

  // 毛利率报表 分页数据
  const getGrossMarginPageList = apiUrl + '/api/Report/GetGrossMarginPageList';

  // 毛利率报表 导出
  const exportGrossMarginExcel = apiUrl + '/api/Report/ExportGrossMarginExcel';

  // 财务单 分页数据
  const loadFinanceStatementPageList = apiUrl + '/api/FinanceStatement/LoadFinanceStatementPageList';

  // 保存财务单信息
  const saveFinanceStatement = apiUrl + '/api/FinanceStatement/SaveFinanceStatement';

  // 获取财务单的主单信息（提货信息、提货日期、备注等）
  function getFinanceStatementInfoById(financeId) {
    return apiUrl + '/api/FinanceStatement/GetFinanceStatementInfoById?financeId=' + financeId;
  }

  // 获取财务单明细数据
  function getDetailsById(financeId) {
    return apiUrl + '/api/FinanceStatement/GetDetailsById?financeId=' + financeId;
  }

  // 把财务单提交
  function commitFinanceById(financeId) {
    return apiUrl + '/api/FinanceStatement/CommitFinanceById?financeId=' + financeId;
  }

  // 把财务单审核
  function checkFinanceById(financeId) {
    return apiUrl + '/api/FinanceStatement/CheckFinanceById?financeId=' + financeId;
  }

  // 把财务单撤回
  function revokeFinanceById(financeId) {
    return apiUrl + '/api/FinanceStatement/RevokeFinanceById?financeId=' + financeId;
  }

  // 备注财务单
  function remarkFinanceById(financeId, remark) {
    return apiUrl + '/api/FinanceStatement/RemarkFinanceById?financeId=' + financeId + '&remark=' + remark;
  }

  // 删除财务单
  function deleteFinanceById(financeId) {
    return apiUrl + '/api/FinanceStatement/DeleteFinanceById?financeId=' + financeId;
  }

  // 导出财务单
  const exportFinanceStatementExcel = apiUrl + '/api/FinanceStatement/ExportFinanceStatementExcel';

  // 获取财务单明细导入模板
  const getFinanceDetailImportExcelTemplet = apiUrl + '/api/FinanceStatement/GetFinanceDetailImportExcelTemplet';

  // 财务单明细导入【仅支持文件放在FormData方式上传】
  function importFinanceDetailExcel(financeId) {
    return apiUrl + '/api/FinanceStatement/ImportFinanceDetailExcel?financeId=' + financeId;
  }

  /**
   *  下拉框公共方法
   * */
  // 获取平台来源下拉框信息
  const getAllPXOpenPlatformList = apiUrl + '/api/SelectsInfo/GetAllPXOpenPlatformList';

  // 获取店铺下拉框信息
  const getAllPXShopList = apiUrl + '/api/SelectsInfo/GetAllPXShopList';

  // 获取渠道下拉框信息
  const getAllStoreroomsList = apiUrl + '/api/SelectsInfo/GetAllStoreroomsList';

  // 获取品牌下拉框信息
  const getAllBrandsList = apiUrl + '/api/SelectsInfo/GetAllBrandsList';

  // 获取码段下拉框信息
  const getAllSizeGroupList = apiUrl + '/api/SelectsInfo/GetAllSizeGroupList';

  // 获取分类下拉框信息
  const getAllClassList = apiUrl + '/api/SelectsInfo/GetAllClassList';

  // 加载对分销商开放的供应商下拉信息
  const getSupplierSelData = apiUrl + '/api/SelectsInfo/GetSupplierSelData';

  // 加载订单来源下拉数据
  const getOrderSourceList = apiUrl + '/api/SelectsInfo/GetOrderSourceList';

  // 获取分销商的线上平台的订单来源下拉框信息
  const getOnlineOpenPlatformList = apiUrl + '/api/SelectsInfo/GetOnlineOpenPlatformList';

  // 加载订单状态下拉数据
  const getOrderSysStatusList = apiUrl + '/api/SelectsInfo/GetOrderSysStatusList';

  // 加载订单备注类型下拉数据
  const getOrderRemarkTypeList = apiUrl + '/api/SelectsInfo/GetOrderRemarkTypeList';

  // 获取快递公司下拉框
  const getAllLogisticList = apiUrl + '/api/SelectsInfo/GetAllLogisticList';

  // 获取快递公司下拉框 -- 待审状态修改物流公司
  function getOrderLogisticByOrderId(orderId) {
    return apiUrl + '/api/Order/GetOrderLogisticByOrderId?orderId=' + orderId;
  }

  // 获取地区下拉框
  const getAllRegionList = apiUrl + '/api/SelectsInfo/GetAllRegionList';

  // 获取省份下拉框
  const getAllProvinceList = apiUrl + '/api/SelectsInfo/GetAllProvinceList';

  // 获取城市下拉框
  function getAllCityList(provinceId) {
    return apiUrl + '/api/SelectsInfo/GetAllCityList?provinceId=' + provinceId;
  }

  // 获取区下拉框
  function getAllAreaList(cityId) {
    return apiUrl + '/api/SelectsInfo/GetAllAreaList?cityId=' + cityId;
  }

  // 获取售后类型下拉框数据
  const getRefundTypeList = apiUrl + '/api/SelectsInfo/GetRefundTypeList';

  // 获取售后状态下拉数据
  const getRefundReStatusList = apiUrl + '/api/SelectsInfo/GetRefundReStatusList';

  // 获取结算状态下拉数据
  const getSettleStatusList = apiUrl + '/api/SelectsInfo/GetSettleStatusList';

  // 获取售后原因下拉框数据
  const getRefundReasonList = apiUrl + '/api/SelectsInfo/GetRefundReasonList';

  // 获取退款状态下拉数据
  const getRefundTuiZtList = apiUrl + '/api/SelectsInfo/GetRefundTuiZtList';

  // 获取售后受理渠道下拉数据
  function getBackStoreroomList(refundId) {
    if (refundId) {
      return apiUrl + '/api/SelectsInfo/GetBackStoreroomList?refundId=' + refundId;
    } else {
      return apiUrl + '/api/SelectsInfo/GetBackStoreroomList';
    }
  }

  // 获取售后来源店铺下拉数据
  const getLaiYuanShopList = apiUrl + '/api/SelectsInfo/GetLaiYuanShopList';

  // 获取售后发出仓库（渠道）下拉数据
  const getSendOutStoreroomList = apiUrl + '/api/SelectsInfo/GetSendOutStoreroomList';

  // 加载分销商充值工单申请人下拉信息
  const getRechargeWorkOrderCreater = apiUrl + '/api/SelectsInfo/GetRechargeWorkOrderCreater';

  // 加载分销商充值工单处理人下拉信息
  const getRechargeWorkOrderChecker = apiUrl + '/api/SelectsInfo/GetRechargeWorkOrderChecker';

  // 加载分销商充值工单充值类型下拉数据
  const getRechargeWorkOrderType = apiUrl + '/api/SelectsInfo/GetRechargeWorkOrderType';

  // 加载分销商充值工单支付方式下拉数据
  const getRechargeWorkOrderPayType = apiUrl + '/api/SelectsInfo/GetRechargeWorkOrderPayType';

  // 加载分销商充值工单状态下拉数据
  const getRechargeWorkOrderStatus = apiUrl + '/api/SelectsInfo/GetRechargeWorkOrderStatus';

  // 加载分销商申诉工单受理方下拉信息
  const getAppealWorkOrderChecker = apiUrl + '/api/SelectsInfo/GetAppealWorkOrderChecker';

  // 加载分销商申诉工单状态下拉数据
  const getAppealWorkOrderStatus = apiUrl + '/api/SelectsInfo/GetAppealWorkOrderStatus';

  // 加载分销商的关联渠道下拉数据
  const getStoreroomIdByClientId = apiUrl + '/api/SelectsInfo/GetStoreroomIdByClientId';

   /*活动链接管理*/
  // 加载店铺活动页面列表
  const LoadShopActivityPageList = apiUrl + '/api/ShopActivity/LoadShopActivityPageList';

  // 新增活动
  const saveActivity = apiUrl + '/api/ShopActivity/SaveActivity';

  // 添加链接/货号
  const saveActivityDetail = apiUrl + '/api/ShopActivity/SaveActivityDetail';

  // 链接批量对接仓库
  const batchSaveActivityStoreroomLinkDocking = apiUrl + '/api/ShopActivity/BatchSaveStoreroomLinkDocking';

  // 开启活动对应的货号或链接的库存对接
  function openActivityStockDocking(activityId) {
    return apiUrl + '/api/ShopActivity/OpenActivityStockDocking?activityId=' + activityId;
  }

  // 关闭活动对应的货号或链接的库存对接
  function closeActivityStockDocking(activityId) {
    return apiUrl + '/api/ShopActivity/CloseActivityStockDocking?activityId=' + activityId;
  }

  // 按链接同步库存
  function synceLinkStock(activityId) {
    return apiUrl + '/api/ShopActivity/SynceLinkStock?activityId=' + activityId;
  }

  // 查看链接
  function getLinkDetailsById(activityId) {
    return apiUrl + '/api/ShopActivity/GetLinkDetailsById?activityId=' + activityId;
  }

  // 查看货号
  function getGoodsDetailsById(activityId) {
    return apiUrl + '/api/ShopActivity/GetGoodsDetailsById?activityId=' + activityId;
  }

  // 货号批量对接仓库
  const batchSaveActivityStoreroomGoodsDocking = apiUrl + '/api/ShopActivity/BatchSaveStoreroomGoodsDocking';

  // 查看同步日志数据
  const loadActivityLogPageList = apiUrl + '/api/ShopActivity/LoadActivityLogPageList';

  // 重新同步未成功数据
  function reSyncFailLinkDetail(activityId) {
    return apiUrl + '/api/ShopActivity/ReSyncFailLinkDetail?activityId=' + activityId;
  }

  // 2025.08.08新加功能
  // 加载条件标签下拉框数据
  const getFilterTagList = apiUrl + '/api/Refund/GetFilterTagList';

  // 获取图片信息
  function getImgById(billId) {
    return apiUrl + 'api/SelectsInfo/GetImgById?billId=' + billId;
  }

  // 复制单个订单
  function copyOrderSingle(orderId) {
    return apiUrl + '/api/Order/CopyOrderSingle?orderId=' + orderId;
  }

  // 获取猫超导入模板
  const getMaoChaoLinkImportExcelTemplet = apiUrl + '/api/ShopDataDownload/GetMaoChaoLinkImportExcelTemplet';

  // 猫超商品信息导入【仅支持文件放在FormData方式上传】
  const importMaoChaoLinkExcel = apiUrl + '/api/ShopDataDownload/ImportMaoChaoLinkExcel';

  function test() {
    console.log('测试测试测试');
  }

  export default {
    tabsChange,
    apiUrl,
    // Header,
    test,
    timeFormatStart,
    timeFormatEnd,
    timeFormatEight,
    timeFormatEightDate,
    addition,
    subtraction,
    multiplication,
    division,
    getToken,
    getSPUrl,
    getWebClienData,
    loginUrl,
    registerUrl,
    getMenuInfoUrl,
    getAgentMainInfo,
    changeAgentAutoPayStatus,
    getRefundCountInfo,
    loadPlatNoticePageData,
    getPlatNoticeById,
    loadSupplierNoticePageData,
    getSupplierNoticeById,
    // getSupplierSelData,
    sendVerifyCode,
    checkAgentOrSupplyAccount,
    checkFindSmsCode,
    sendFindPwdSmsCode,
    findPwdChange,
    changeUserPwd,
    // getBrandSelData,
    // getSizeGroupSelData,
    // getClassSelData,
    loadGoodsPageList,
    downMainImg,
    downImgZip,
    loadAllGroupGoodsDetailPageData,
    getGoodsInfoById,
    searchGoodsSkuInfo,
    getGroupGoodsDetailInfoById,
    saveAddOrUpdateGroupGoodsCodeInfo,
    delGroupGoodsById,
    getGroupGoodsImportExcelTemplet,
    importGroupGoodsExcel,
    loadProxyAllStoreroomPageData,
    getStoreroomModelById,
    openOrCloseAfteSale,
    loadPFGoodsPageData1,
    // getGoodsInfoById,
    // getAllStoreroomsList,
    // getAllBrandsList,
    loadAllStoreroomStockPageData,
    exportStoreroomStockData,
    loadAgentGoodsCostPricePageData,
    exportAgentGoodsCostPriceData,
    getStoreroomGoodsLogisticPageData,
    saveStoreroomGoodsLogisticInfo,
    delStoreroomGoodsLogisticByIds,
    getStoreroomProvinceLogisticPageData,
    getRegionProvinceList,
    saveStoreroomProvinceLogisticInfo,
    delStoreroomProvinceLogisticByIds,
    loadAllShopGoodsPageData,
    exportShopGoodsExcel,
    getGoodsDetail,
    downloadGoodsImgZipRar,
    getLinkDetailInfoById,
    synchOneLinkStock,
    loadGoodsStoreroomDatatableList,
    getStoreroomListByShopId,
    batchSaveStoreroomGoodsDocking,
    batchCloseGoodsStockDocking,
    saveStoreroomGoodsInfo,
    synchGoodsStock,
    goodsGoOrDownIng,
    loadAllShopLinkPageData,
    exportShopLinkExcel,
    getShopLinkSkuId,
    synchrBatchLinkBusinessCode,
    getStoreroom,
    saveStoreroomLinksInfo,
    batchSaveStoreroomLinkDocking,
    batchCloseLinkStockDocking,
    synchLinkStock,
    getGoodsOnDrwn,
    batchSynchLinkStock,
    loadAllLinkErrorPageData,
    exportShopErrorLinkExcel,
    getLinkErrorSkuId,
    synchrBatchBusinessCode,
    downLink,
    loadAllAgentStoreroomLogisticPostagePageData,
    exportAgentStoreroomLogisticPostageData,
    getDewuShopList,
    loadDewuPricePageList,
    exportDewuPriceExcel,
    batchCancelDewuPriceByNumId,
    downAllPlatBidPrice,
    getDewuPriceLogList,
    getDewuPriceDetailListByNumId,
    cancelDewuPriceByNumId,
    downDewuLinkPriceByNumId,
    getLowestPriceBySkuIds,
    getStockBySkuIds,
    cancelDewuPriceBySkuIds,
    confirmBidPrice,
    getStoreroomGoodsLogisticImportExcelTemplet,
    importStoreroomGoodsLogisticExcel,
    exportRefundExcel,
    loadRefundPageData,
    getRefundLogs,
    changeRefundStatus,
    closeRefund,
    getAgentStoreroomById,
    shouLiRefund,
    saveRefundReType,
    saveRefundReason,
    saveRefundDetails,
    getOrderRefundRelationList,
    getOrderData,
    checkRefundExpressNumIsUsed,
    saveRefundLogisticInfo,
    saveRefundTuiMoney,
    saveAgentPXExtMoney,
    saveAgentRemark,
    saveRefundMessage,
    getRefundDailyReturnGoods,
    getRefundLogisticData,
    confirmReceipt,
    refundResubmit,
    createNewOrder,
    getCreateNewOrder,
    newCreateNewOrder,
    getRefundDataByRefundId,
    checkExpressNumIsUsed,
    saveRefundInfo,
    getOrderImportExcelTemplet,
    importOrderExcel,
    getAgentOrderListPageData,
    getPlatformCommitOrderListPageData,
    loadOrderPageList,
    batchPayOrder,
    payAllOrder,
    mergeOrder,
    verifyOrder,
    verifyOrderSingle,
    verifyAllOrder,
    batchActiveOrder,
    activeOrderSingle,
    batchCancelOrder,
    cancelOrderSingle,
    editRemarkMemoByOrderId,
    batchEditAgentRemark,
    batchEditSellerMemo,
    syncOnlineOrderSend,
    editSellerMemo,
    editSellerMemoSingle,
    editAgentRemark,
    editAgentRemarkSingle,
    revokeOrder,
    getOrderDetail,
    editOrderExpressInfo,
    saveOrderLogistic,
    cancelOrderAsyncFailFlag,
    batchRevokeOrder,
    getOrderCost,
    manualSplitOrder,
    viewSplitOrderInfo,
    getGoodsInfoByGoodsId,
    saveChangeGoods,
    getOrderChangeStoreroom,
    saveReceiveInfo,
    saveOrderChangeStoreroom,
    verifyAppendGoods,
    appendGoods,
    resetOrderStoreroom,
    batchResetOrderStoreroom,
    autoSplitOrder,
    getOrderDetailStoreroomInfo,
    getOrderAllDetailStoreroomInfo,
    getOrderLogs,
    exportOrderExcel,
    exportDetailExcel,
    getShopGoodsPricePageList,
    getShopGoodsPriceById,
    updateShopGoodsPrice,
    deleteShopGoodsPriceById,
    exportShopGoodsPriceExcel,
    getShopGoodsPriceImportExcelTemplet,
    importShopGoodsPriceExcel,
    getPriceRangeSelData,
    getCostDiscountSelData,
    getMarketYearSelData,
    getRetailGoodsPageData,
    getStockExportColumn,
    exportGoodsIdStockExcel,
    getShoppingCartData,
    addToShoppingCart,
    delShoppingCartById,
    checkReceiveNameHaveOrders,
    settlementOrder,
    submitOrders,
    getRechargeWorkOrderList,
    deleteRechargeWorkOrder,
    getAppealWorkOrderList,
    saveAppealWorkOrder,
    deleteAppealWorkOrder,
    checkOrderIdCreateAppealWorkOrder,
    changeAppealWorkOrderZt,
    getWorkOrderLogList,
    getFundAccountList,
    saveRechargeWorkOrder,
    editPayPwd,
    getWaterStatus,
    getAccountBalanceHistoryDetailList,
    exportAccountBalanceHistoryDetailList,
    getClientRoleData,
    saveUser,
    getUseList,
    getProxyQQ,
    saveProxyQQ,
    resetPwd,
    changeStatus,
    deleteUser,
    getRoleList,
    getRoleCompetenceData,
    saveRoleCompetenceData,
    saveRole,
    changeRoleStatus,
    deleteRole,
    loadAgentShopPageData,
    // getAllPXOpenPlatformList,
    updateOneShopGoodsStock,
    getShopModelById,
    saveAddOrUpdateShopInfo,
    changeShopLocakStatusById,
    delShopInfoById,
    // getShopDockingKeyword,
    loadAllShopBindStoreroomAndStoreroomData,
    saveShopBindStoreroomInfo,
    getShopDockingKeyword,
    getSynchTradeSetting,
    synchTradeSetting,
    viewRejectReason,
    loadAllStoreroomData,
    getBindSupplier,
    saveBindSupplier,
    relieveSupplierBind,
    getDockingSynchTypeList,
    changeShopAsynTimeById,
    changeShopStatusById,
    downOrderById,
    downOrderByCreateTime,
    downReOrderById,
    downReOrderByCreateTime,
    downGoodsByLinkId,
    downShopGoodsList,
    getShopAppInfoById,
    // changeShopAsynTimeById,
    // changeShopStatusById,
    getSelftStoreroomIdByClientId,
    getSelftStoreCostPageList,
    exportSelfCostExcel,
    editCostDiscout,
    getSelfCostImportExcelTemplet,
    importSelfCostExcel,
    getSelfCostLog,
    getGrossMarginPageList,
    exportGrossMarginExcel,
    loadFinanceStatementPageList,
    saveFinanceStatement,
    getFinanceStatementInfoById,
    getDetailsById,
    commitFinanceById,
    checkFinanceById,
    revokeFinanceById,
    remarkFinanceById,
    deleteFinanceById,
    exportFinanceStatementExcel,
    getFinanceDetailImportExcelTemplet,
    importFinanceDetailExcel,
    getAllPXOpenPlatformList,
    getAllPXShopList,
    getAllStoreroomsList,
    getAllBrandsList,
    getAllSizeGroupList,
    getAllClassList,
    getSupplierSelData,
    getOrderSourceList,
    getOnlineOpenPlatformList,
    getOrderSysStatusList,
    getOrderRemarkTypeList,
    getAllLogisticList,
    getOrderLogisticByOrderId,
    getAllRegionList,
    getAllProvinceList,
    getAllCityList,
    getAllAreaList,
    getRefundTypeList,
    getRefundReStatusList,
    getSettleStatusList,
    getRefundReasonList,
    getRefundTuiZtList,
    getBackStoreroomList,
    getLaiYuanShopList,
    getSendOutStoreroomList,
    getRechargeWorkOrderCreater,
    getRechargeWorkOrderChecker,
    getRechargeWorkOrderType,
    getRechargeWorkOrderPayType,
    getRechargeWorkOrderStatus,
    getAppealWorkOrderChecker,
    getAppealWorkOrderStatus,
    getStoreroomIdByClientId,
    LoadShopActivityPageList,
    saveActivity,
    saveActivityDetail,
    batchSaveActivityStoreroomLinkDocking,
    openActivityStockDocking,
    closeActivityStockDocking,
    synceLinkStock,
    getLinkDetailsById,
    getGoodsDetailsById,
    batchSaveActivityStoreroomGoodsDocking,
    loadActivityLogPageList,
    reSyncFailLinkDetail,
    getFilterTagList,
    getImgById,
    copyOrderSingle,
    getMaoChaoLinkImportExcelTemplet,
    importMaoChaoLinkExcel
  }
</script>



// WEBPACK FOOTER //
// src/components/public-component/global.vue